import React, { useContext, useState } from 'react'
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
} from '@material-ui/core'
import { KeyboardArrowRight, MoreVert } from '@material-ui/icons'
import { DeleteDialog } from 'components/Dialog/DeleteDialog'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  useDeleteFaChangeApportionmentMutation,
  useGetDocNumTitleQuery,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'

interface EntryListProps {
  filteredList: any[]
  listLoading: boolean
  listStatus: string
  userList: any[]
  fetchMore: Function
  setOriginalListing: Function
  hasMore: boolean
}

export const ChangeApportionmentEntryList = (props: EntryListProps) => {
  const {
    filteredList,
    listLoading,
    listStatus,
    fetchMore,
    setOriginalListing,
    hasMore,
  } = props

  const {
    handleClick,
    anchorEl,
    menu,
    handleClose,
    resetMenu,
  } = useMenuOption()
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const [deleteDialog, setDeleteDialog] = useState(false)
  const history = useHistory()
  const { CompanyID }: any = useParams()
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))

  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID, RefTable: 'fa_change_apportionment' },
    onError: ({ message }) => {
      const error = message?.substring(15)
      setErrMsg(error)
      setErrorDia(true)
    },
  })

  const docNumChecker = getDocumentNumberHeader?.length === 0

  // Delete mutation
  const [
    deleteApportionment,
    { loading: deleteLoading },
  ] = useDeleteFaChangeApportionmentMutation({
    onError: ({ message }) => {
      const error = message?.substring(15)
      setErrMsg(error)
      setErrorDia(true)
      setDeleteDialog(false)
      resetMenu()
    },
    onCompleted: data => {
      if (data?.DeleteFAChangeApportionment) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.deleteRecord())
        setDeleteDialog(false)
        setOriginalListing([])
        resetMenu()
        fetchMore({
          variables: {
            CompanyID: CompanyID,
            StatusArr: [listStatus],
            take: 30,
            skip: 0,
            searchValue:
              getSearch?.name === '' || getSearch?.name === undefined
                ? undefined
                : getSearch?.name,
          },
        })
      }
    },
  })

  const handleDelete = () => {
    if (menu?.obj?.apportionment_id) {
      deleteApportionment({
        variables: {
          apportionment_id: menu.obj.apportionment_id,
        },
      })
    }
  }

  const getTotalPercentageChange = (details: any[]) => {
    if (!details || details.length === 0) return 0
    return details.reduce((sum, d) => {
      const diff = Math.abs((d.new_percentage || 0) - (d.old_percentage || 0))
      return sum + diff
    }, 0)
  }
  const { handlePermDisabled } = usePermissionChecker()

  return (
    <>
      {listLoading && <Loading />}
      {deleteLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}

      <ContentWrapper advSearch float>
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList)?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length || 0}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name !== '' && getSearch?.name !== undefined
                        ? getSearch?.name
                        : undefined,
                  },
                })
              }}
              hasMore={hasMore}
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)
                ?.sort((a, b) => {
                  return (
                    Object.values(ApprovalStatus).indexOf(a?.ApprovalStatus) -
                    Object.values(ApprovalStatus).indexOf(b?.ApprovalStatus)
                  )
                })
                ?.map((el, index) => {
                  const totalChange = getTotalPercentageChange(el?.Details)
                  return (
                    <ListItem key={index}>
                      <ListItemText
                        primary={
                          <>
                            <span className="desc date-width">
                              {`${formatDate(el?.change_date)}` || 'N/A'}
                            </span>
                            <span className="xsTitle flex-space">
                              {el?.DocNo}
                            </span>
                            <span className="xsTitle">{el?.Asset?.name}</span>
                          </>
                        }
                        secondary={
                          <>
                            <Grid container spacing={0}>
                              <Grid container className="table-content">
                                <Grid item xs={6}>
                                  <span className="desc flex-space">
                                    {el?.Asset?.Category?.name}
                                  </span>
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  style={{ textAlign: 'right' }}
                                >
                                  <span className="desc">
                                    <span style={{ color: '#666' }}>
                                      {el?.Details?.length || 0} dept(s)
                                    </span>
                                    {' | '}
                                    <span style={{ color: 'orange' }}>
                                      {totalChange.toFixed(2)}% changed
                                    </span>
                                  </span>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid item xs={12}>
                                  <span className="desc">{el?.reason}</span>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        }
                      />

                      <ListItemSecondaryAction>
                        {listStatus === 'ACTIVE' ||
                        listStatus === 'REJECTED' ? (
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            aria-controls="menu-list"
                            aria-haspopup="true"
                            onClick={e =>
                              handleClick(e, el?.apportionment_id, index, el)
                            }
                          >
                            <MoreVert />
                          </IconButton>
                        ) : (
                          <IconButton edge="end" aria-label="arrow">
                            <KeyboardArrowRight
                              onClick={() =>
                                history.push({
                                  pathname: `/fixed-assets/${CompanyID}/assets-change/change-apportionment/${el?.apportionment_id}/detail`,
                                  state: el,
                                })
                              }
                            />
                          </IconButton>
                        )}
                      </ListItemSecondaryAction>
                    </ListItem>
                  )
                })}
            </InfiniteScroll>
          )}
        </List>

        {listStatus === 'ACTIVE' && (
          <FloatButton
            onClick={() => {
              if (docNumChecker) {
                setOpenSnackBar(true)
                setSnackBarMsg(SystemMsgs.errorNumberingStructure())
              } else {
                history.push(
                  `/fixed-assets/${CompanyID}/assets-change/change-apportionment/add`
                )
              }
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsApportionmentCreate,
            })}
          />
        )}
      </ContentWrapper>

      {listStatus === 'ACTIVE' ? (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-change/change-apportionment/${menu?.obj?.apportionment_id}/edit`,
                state: menu?.obj,
              })
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsApportionmentUpdate,
            })}
          >
            <span>Edit</span>
          </MenuItem>
          <MenuItem
            onClick={() => setDeleteDialog(true)}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsApportionmentDelete,
            })}
          >
            <span>Delete</span>
          </MenuItem>
        </Menu>
      ) : (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-change/change-apportionment/${menu?.obj?.apportionment_id}/edit`,
                state: { ...menu?.obj, mode: 'resubmit' },
              })
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsApportionmentUpdate,
            })}
          >
            <span>Resubmit</span>
          </MenuItem>
        </Menu>
      )}

      <DeleteDialog
        ID={menu?.ID}
        openDeleteDialog={deleteDialog}
        setOpenDeleteDialog={setDeleteDialog}
        title={'Change Apportionment'}
        menu={menu?.obj}
        handleDelete={handleDelete}
        passID={menu?.ID}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error'}
      />
    </>
  )
}
